import axiosInstance from './axiosInstance';

const updateConfigUser = ({
  id,
  data: { active, toDonations, useQrSalesOrder },
}) =>
  axiosInstance.patch(`/internal/admin/users/${id}`, {
    active,
    to_donations: toDonations,
    use_qr_sales_order: useQrSalesOrder,
  });

export default updateConfigUser;
